import { BouSpacingLevel, fluidHorizontalPadding } from '@upright/ui/common/generic/layout/bou-spacing';
import styled from 'styled-components';
import { ModelReleaseText } from '../../model-release-text';
import { useSdgAlignmentsContext } from './context';

export const SdgModelVersionText = () => {
  const context = useSdgAlignmentsContext();
  if (!context.release || !context.version) {
    return null;
  }
  return (
    <Root>
      <ModelReleaseText release={context.release} version={context.version} showTimeZone />
    </Root>
  );
};

const Root = styled.div`
  ${fluidHorizontalPadding(BouSpacingLevel.SMALL)}
  margin-top: 1em;
  margin-bottom: 1em;
`;
